<template>
  <div class="quote" :style="{backgroundColor: backgroundColour ? backgroundColour : '#86C8BC'}">
    <div class="grid-x">
      <div class="small-10 small-offset-1">
        <p class="quote-text text -semibold">{{ text }}</p>
        <p class="text -t3 author" v-html="author"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      backgroundColour: String,
      text: String,
      author: String
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .quote {
    background-image: url('~@/assets/images/watermark.svg');
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: vw-relative(100, 320);
    padding: vw-relative(30, 320) 0;
    margin-bottom: vw-relative(30, 320);
    @include breakpoint(medium) {
      padding: vw-relative(60) 0;
      margin-bottom: vw-relative(30);
      background-size: auto 75%;
      background-position: 100% 100%;
    }
  }
  .quote-text {
    margin: 2em 0 1em;
    &:before {
      display: block;
      content: '“';
      font-size: 6em;
      line-height: 0;
    }
  }
  .author {
    text-align: center;
  }
</style>
